import type { IconData } from '@stacksjs/iconify-core'

export const attribution: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M24 3a21 21 0 1 0 0 42a21 21 0 1 0 0-42\"/><path d=\"M28.79 15.79a4.78 4.78 0 0 1-1.82 3.757c2.88.313 5.03 2.65 5.03 5.624c0 1.622-.202 2.729-.349 3.32c-.084.338-.302.617-.629.74c-.41.154-1.134.357-2.345.516c-.2 1.852-.517 3.99-1.015 5.776c-.142.511-.508.928-1.015 1.085A9 9 0 0 1 24 37a9 9 0 0 1-2.648-.392c-.507-.157-.872-.574-1.015-1.085c-.497-1.786-.815-3.924-1.015-5.776c-1.21-.159-1.933-.362-2.344-.516c-.327-.122-.545-.402-.63-.74c-.146-.592-.348-1.698-.348-3.32c0-2.974 2.15-5.311 5.03-5.624a4.79 4.79 0 1 1 7.76-3.758Z\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default attribution
